export const routePaths = {
  clinicManagement: "/clinicManagement",
  editclinicDetails: "/editClinicDetails",
  viewClinicDetails: "/viewClinicDetails",
  communicationLogs: "/communicationLogs",
  userManagement: "/userManagement",
  clinicDetails: "/clinicDetails/:applicationUserId",
  login: "/login",
  otp: "/otp",
  setPassword: "/setPassword",
  register: "/register",
  reporting: "/reporting/:applicationUserId",
  patientsInDrafts: "/patientsInDrafts/:applicationUserId",
  base: "/",
  wild: "*",
};
